import { render } from "./ProductosRecepcion.vue?vue&type=template&id=e930da06&scoped=true"
import script from "./ProductosRecepcion.vue?vue&type=script&lang=js"
export * from "./ProductosRecepcion.vue?vue&type=script&lang=js"

import "./ProductosRecepcion.vue?vue&type=style&index=0&id=e930da06&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e930da06"]])

export default __exports__